export default __webpack_public_path__ + "static/107981-6db3cf1953d1da0cb7d8b12fdfb0033f.jpg";